import currency from "currency.js";
import { getDefaultNumberFormat, getNumberFormatSeparators } from "./defaultNumberFormat";

function normalizeNumericValue(value) {
  if (typeof value === "number") return value;
  if (typeof value !== "string") return Number(value);

  const trimmed = value.trim();
  if (!trimmed) return Number.NaN;

  // Legacy strings may contain spaces as thousands separators.
  const normalized = trimmed.replace(/\s+/g, "").replace(",", ".");
  return Number(normalized);
}

export function formatNumberWithSiteFormat(value, { decimals, legacyFormatter } = {}) {
  const configuredNumberFormat = getDefaultNumberFormat();
  if (!configuredNumberFormat) {
    if (typeof legacyFormatter === "function") return legacyFormatter(value);
    if (typeof decimals === "number") return Number(value).toFixed(decimals);
    return `${value}`;
  }

  const numericValue = normalizeNumericValue(value);
  if (Number.isNaN(numericValue)) return `${value}`;

  const precision = typeof decimals === "number"
    ? decimals
    : (Number.isInteger(numericValue) ? 0 : 2);

  const separators = getNumberFormatSeparators(configuredNumberFormat);
  if (!separators) {
    if (typeof legacyFormatter === "function") return legacyFormatter(value);
    return `${value}`;
  }

  return currency(numericValue, {
    symbol: "",
    separator: separators.separator,
    decimal: separators.decimal,
    precision,
    pattern: "#",
    negativePattern: "-#",
  }).format();
}
